var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57495 29.2426C9.57495 29.2426 28.1505 21.5594 34.5929 18.854C37.0625 17.7719 45.4376 14.309 45.4376 14.309C45.4376 14.309 49.3031 12.794 48.9809 16.4733C48.8735 17.9883 48.0146 23.2908 47.1556 29.0262C45.8671 37.1423 44.4712 46.0158 44.4712 46.0158C44.4712 46.0158 44.2565 48.5048 42.4312 48.9377C40.6059 49.3705 37.5993 47.4228 37.0625 46.9898C36.6329 46.6652 29.0095 41.7955 26.2178 39.4148C25.4662 38.7655 24.6072 37.467 26.3251 35.9519C30.1906 32.3808 34.8076 27.9441 37.5993 25.1305C38.8878 23.8319 40.1762 20.8019 34.8076 24.4811C27.1842 29.7837 19.668 34.7616 19.668 34.7616C19.668 34.7616 17.95 35.8437 14.7289 34.8697C11.5076 33.8959 7.74949 32.5973 7.74949 32.5973C7.74949 32.5973 5.17268 30.9741 9.57495 29.2426Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3c8405637865f21a11b3286887e81ec6.svg";
export { ForwardRef as ReactComponent };